const TOKEN_KEY = 'admin-token'

export function getAdminToken () {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setAdminToken (token) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  else localStorage.removeItem(TOKEN_KEY)
}

export async function adminApi (url, { method = 'GET', body } = {}) {
  const token = getAdminToken()
  const res = await fetch(`/admin/api${url}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: body === undefined ? undefined : JSON.stringify(body)
  })
  const json = await res.json().catch(() => ({ success: false, message: '无法解析响应' }))
  if (!json.success) {
    const err = new Error(json.message || '请求失败')
    err.code = json.errorCode
    err.status = res.status
    throw err
  }
  return json.data
}
